<footer class='text-right'>
  <p class='text-center'>Keep calm and compile</p>
</footer>
